import React from 'react';
import { Drawer as AntdDrawer, DrawerProps } from 'antd';

/*
    Custom AntdDrawer is created to avoid problem with blocking page after closing Drawer
*/

export class Drawer extends React.Component<DrawerProps> {
  prevStyles: Partial<CSSStyleDeclaration> = {};

  getSnapshotBeforeUpdate() {
    this.prevStyles = {
      overflow: document.body.style.overflow,
      overflowX: document.body.style.overflowX,
      overflowY: document.body.style.overflowY,
    };

    return null;
  }

  componentDidUpdate() {
    document.body.style.overflow = this.prevStyles.overflow!;
    document.body.style.overflowX = this.prevStyles.overflowX!;
    document.body.style.overflowY = this.prevStyles.overflowY!;
  }

  render() {
    return <AntdDrawer {...this.props}>{this.props.children}</AntdDrawer>;
  }
}
